module.exports = __webpack_public_path__ + "img/problem.54a49c50.png";